<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <tax-slab
          :singlePage="true"
          :showGrid1="false"
          @select="select"
          @closeDialog="closeDialog"
          :showClose="true"
          :showSelectBtn="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import TaxSlab from "@/views/taxslab/TaxSlab.vue";

@Component({
  name: "TaxCreate",
  components: {
    TaxSlab,
  },
  props: {
    showDialog: {
      default: false,
    },
  },
})
export default class TaxCreate extends Vue {
  dialog = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  select(newVal) {
    this.dialog = false;
    this.$emit("select", newVal);
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }
}
</script>
